import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class MspFaviconService {
	constructor(@Inject(DOCUMENT) private document: Document) {}

	setFavicon(href: string, type = 'image/x-icon'): void {
		if (!href || href.trim() === '') return;

		const iconLink = this.getOrCreateLinkTag('icon');
		iconLink.type = type;
		iconLink.href = href;

		const shortcutIconLink = this.getOrCreateLinkTag('shortcut icon');
		shortcutIconLink.type = type;
		shortcutIconLink.href = href;
	}

	getFavicon(): string {
		const iconLink = this.document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
		if (iconLink?.href) return iconLink.href;

		const shortcutIconLink = this.document.querySelector("link[rel='shortcut icon']") as HTMLLinkElement | null;
		return shortcutIconLink?.href || '';
	}

	resetFavicon(defaultHref = 'favicon.ico', type = 'image/x-icon'): void {
		this.setFavicon(defaultHref, type);
	}

	private getOrCreateLinkTag(rel: string): HTMLLinkElement {
		let linkTag = this.document.querySelector(`link[rel='${rel}']`) as HTMLLinkElement | null;

		if (!linkTag) {
			linkTag = this.document.createElement('link');
			linkTag.rel = rel;
			this.document.head.append(linkTag);
		}

		return linkTag;
	}

	getLogoSource(darkMode: boolean = window.matchMedia('(prefers-color-scheme: dark)').matches): string {
		return environment.logoSource + (darkMode ? 'logo_dark_icon.svg' : 'logo_light_icon.svg');
	}
}
